module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_black-d30c569e375d4378975ef40a61224f86.svg";